import { render, staticRenderFns } from "./InterfaceArray.vue?vue&type=template&id=f5d1cc30"
import script from "./InterfaceArray.vue?vue&type=script&lang=js"
export * from "./InterfaceArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports